import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'orbit-farm-save-sucess',
  templateUrl: './farm-save-sucess.component.html',
  styleUrls: ['./farm-save-sucess.component.scss'],
})
export class FarmSaveSucessComponent implements OnInit {
  @Input() farmName: string = ""
  @Input() canvas: any
  @Input() isGuest: boolean = false

  @Output() action: EventEmitter<any> = new EventEmitter<any>()

  constructor() { }

  ngOnInit() { }

  onClick(prop) {
    this.action.emit({ action: prop })
  }

}
